import * as React from 'react'

const SvgPlayingMusicIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 14V4.29616C6.5 3.89488 6.5 3.69424 6.573 3.53151C6.63735 3.38806 6.74097 3.26574 6.87189 3.17868C7.0204 3.07992 7.21831 3.04694 7.61413 2.98097L14.9475 1.75875C15.4816 1.66972 15.7487 1.62521 15.9568 1.70252C16.1395 1.77036 16.2926 1.90006 16.3895 2.06907C16.5 2.26167 16.5 2.53243 16.5 3.07394V12.3333M6.5 14C6.5 15.3807 5.38071 16.5 4 16.5C2.61929 16.5 1.5 15.3807 1.5 14C1.5 12.6193 2.61929 11.5 4 11.5C5.38071 11.5 6.5 12.6193 6.5 14ZM16.5 12.3333C16.5 13.714 15.3807 14.8333 14 14.8333C12.6193 14.8333 11.5 13.714 11.5 12.3333C11.5 10.9526 12.6193 9.83332 14 9.83332C15.3807 9.83332 16.5 10.9526 16.5 12.3333Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgPlayingMusicIcon
